var React = require('react');

function IconProhibitCircleO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M510.3 61.4c-247.4 0-448 200.5-448 448s200.5 448 448 448 448-200.5 448-448c0-247.3-200.6-448-448-448zm0 831.5c-211.8 0-383.5-171.7-383.5-383.5s171.7-383.5 383.5-383.5 383.5 171.7 383.5 383.5c0 211.9-171.7 383.5-383.5 383.5z","key":0}),React.createElement("path",{"d":"M266.3 477.1h488.4c5.5 0 10 4.5 10 10v45.5c0 5.5-4.5 10-10 10H266.3c-5.5 0-10-4.5-10-10v-45.5c0-5.5 4.5-10 10-10z","key":1})]);
}

IconProhibitCircleO.displayName = "IconProhibitCircleO";

IconProhibitCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconProhibitCircleO;

IconProhibitCircleO.default = IconProhibitCircleO;
